import moment from 'moment';
import React, { useState } from 'react';

import { dateService } from '../../../services/date';
import { session } from '../../../services/session';
import DatePicker from '../../base/date/date-picker';
import MerchantStrategyTotals from './merchant-strategy-totals';
import StrategyPerformanceGraph from './strategy-performance-graph';
import TopFiveTable from './top-five-table';

import './strategy-performance-summary.scss';

function StrategyPerformanceSummary({ strategyId, defaultDates, pastDateThreshold, futureLimit }) {
  /* STATE */
  const [dateRange, setDateRange] = useState(defaultDates);

  /* METHODS */
  function setDates(startDate, endDate) {
    setDateRange({
      startDate: dateService.dateFromStr(startDate),
      endDate: dateService.dateFromStr(endDate),
    });
  }

  /* RENDER */
  const today = moment();
  return (
    <div className="strategy-performance-summary">
      <div className="overview-header">
        <h2 className="title">Overview</h2>
        <DatePicker
          eventPrefix="Strategy Performance Summary Date Picker"
          setDateRange={setDates}
          dateRange={dateRange}
          allowFutureDates={false}
          futureLimit={futureLimit}
          disablePastDates={!!pastDateThreshold}
          pastDateThreshold={pastDateThreshold}
        />
      </div>
      <MerchantStrategyTotals
        merchId={session.orgId}
        statType="merchant-performance-overview"
        dateRange={dateRange}
        strategyId={strategyId}
        hidePercentDifference={dateRange.endDate.format('D-M-Y') !== today.format('D-M-Y')}
      />
      <StrategyPerformanceGraph strategyId={strategyId} dateRange={dateRange} />
      <TopFiveTable
        strategyId={strategyId}
        merchId={session.orgId}
        type="publishers"
        dateRange={dateRange}
      />
      <TopFiveTable
        strategyId={strategyId}
        merchId={session.orgId}
        type="stories"
        dateRange={dateRange}
      />
    </div>
  );
}

export default StrategyPerformanceSummary;
